import { NavLink } from 'react-router';

/** Reiter des Moduls: Aufgaben sind eine Liste, Termine ein Kalender. Beide Seiten zeigen sie über ihrer Überschrift. */
export function CalendarTabs() {
  return (
    <nav className="subnav" aria-label="Bereiche von Termine und Aufgaben">
      <NavLink to="/kalender/aufgaben">Aufgaben</NavLink>
      <NavLink to="/kalender/termine">Termine</NavLink>
    </nav>
  );
}
